<div class="container-fluid mb-2">
  <div class="row">
    <div class="col-12 mt-2">
      <mat-tab-group mat-align-tabs="start" (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Nova">
          <app-associacao-stepper #associacaoGrupoCarteiraStepper></app-associacao-stepper>
        </mat-tab>
        <mat-tab label="Importação em lote">
          <app-importacao-lote [tipo]="tipo" (onBaixarModelo)="downloadModelo()"
                               #associacaoImportacaoLote></app-importacao-lote>
        </mat-tab>
        <mat-tab label="Gerenciar registros">
          <app-associacao-grupo-carteira-gerenciador #associacaoGerenciador></app-associacao-grupo-carteira-gerenciador>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="mt-2"></div>
  </div>
</div>
